import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'relativeTime'
})
export class RelativeTimePipe implements PipeTransform {
    transform(timestamp: string, languageCode: string): string {
        if (!timestamp) {
            return '';
        }

        const now = new Date();
        const date = new Date(timestamp);

        const timeDifference = now.getTime() - date.getTime();

        const seconds = Math.floor(timeDifference / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);

        const months = Math.floor(weeks / 4);
        const years = Math.floor(months / 12);

        if (languageCode === 'ar') {
            if (seconds < 60) {
                return 'الآن';
            } else if (minutes < 60) {
                return `قبل ${minutes} دقيقة${minutes > 1 ? '' : ''}`;
            } else if (hours < 24) {
                return `قبل ${hours} ساعة${hours > 1 ? '' : ''}`;
            } else if (days < 7) {
                return `قبل ${days} يوم${days > 1 ? '' : ''}`;
            } else if (weeks < 4) {
                return `قبل ${weeks} أسبوع${weeks > 1 ? '' : ''}`;
            } else if (months < 12) {
                return `قبل ${months} شهر${months > 1 ? '' : ''}`;
            } else {
                return `قبل ${years} سنة${years > 1 ? '' : ''}`;
            }
        } else { // Default to English
            if (seconds < 60) {
                return 'now';
            } else if (minutes < 60) {
                return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
            } else if (hours < 24) {
                return `${hours} hour${hours > 1 ? 's' : ''} ago`;
            } else if (days < 7) {
                return `${days} day${days > 1 ? 's' : ''} ago`;
            } else if (weeks < 4) {
                return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
            } else if (months < 12) {
                return `${months} month${months > 1 ? 's' : ''} ago`;
            } else {
                return `${years} year${years > 1 ? 's' : ''} ago`;
            }
        }
    }
}
